import { Text, UnstyledButton } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

const SELECTED_FILL = 'var(--mantine-color-sage-1, #eef4f0)';
const SELECTED_TEXT = 'var(--mantine-color-sage-7, #3d5c47)';
const SUGGESTION_TEXT = 'var(--mantine-color-sage-6, #5a7d66)';

const pillBase = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  borderRadius: 9999,
  fontFamily: 'inherit',
  lineHeight: 1.2,
};

export function SelectedChip({
  label,
  onRemove,
  prefix = '',
  muted = false,
  removeAriaLabel,
}) {
  return (
    <span
      style={{
        ...pillBase,
        padding: '6px 12px',
        fontSize: 14,
        fontWeight: 500,
        background: muted ? 'var(--aviary-disabled, #e8e8e8)' : SELECTED_FILL,
        color: SELECTED_TEXT,
        opacity: muted ? 0.55 : 1,
      }}
    >
      {prefix}
      {label}
      {onRemove && (
        <UnstyledButton
          onClick={onRemove}
          style={{ display: 'flex', lineHeight: 0, color: 'inherit' }}
          aria-label={removeAriaLabel || `Remove ${label}`}
        >
          <IconX size={12} />
        </UnstyledButton>
      )}
    </span>
  );
}

export function SuggestionChip({
  label,
  onClick,
  disabled = false,
  used = false,
  toggleable = false,
}) {
  const inactive = disabled || (used && !toggleable);
  return (
    <button
      type="button"
      onClick={inactive ? undefined : onClick}
      disabled={inactive}
      style={{
        ...pillBase,
        padding: '6px 10px',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0.35,
        textTransform: 'uppercase',
        background: 'transparent',
        color: SUGGESTION_TEXT,
        border: 'none',
        cursor: inactive ? 'default' : 'pointer',
        opacity: used && !toggleable ? 0.45 : 1,
      }}
    >
      {label}
    </button>
  );
}

export function SuggestionsLabel({ children = 'Suggestions' }) {
  return (
    <Text size="xs" style={{ color: 'var(--aviary-muted)' }}>
      {children}
    </Text>
  );
}
